import { object, string } from 'yup'
import { IpRegion } from './ip-locate.types'

export const IpRegionSchema = object<IpRegion>().shape({
  city: string().required(),
  state: string().required(),
  postalCode: string().optional(),
})
